export function Privacy() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold tracking-tight">Politica de privacidad</h1>
      <p className="mt-2 text-sm text-text-tertiary">
        Ultima actualizacion: 25/04/2026 — Borrador inicial.
      </p>

      <div className="prose prose-slate dark:prose-invert mt-8 max-w-none">
        <p className="text-text-secondary">
          ExamsReactor recopila y trata datos personales en cumplimiento de la{' '}
          <strong>Ley 29733 de Proteccion de Datos Personales</strong> del Peru y su Reglamento
          (Decreto Supremo 016-2024-JUS), asi como del{' '}
          <strong>Reglamento General de Proteccion de Datos (GDPR)</strong> en la Union Europea.
        </p>

        <h2 className="mt-8 text-2xl font-bold">Responsable del tratamiento</h2>
        <p className="text-text-secondary">
          Paul Marquina, operando temporalmente como Persona Natural con Negocio (RUC pendiente
          de comunicar), con sede en Peru. La operacion sera transferida a una Sociedad Anonima
          Cerrada (SAC) en formacion en cuanto se complete su inscripcion.
        </p>
        <p className="text-text-secondary">
          Contacto: <a href="mailto:paul.marquina@outlook.com" className="text-accent-primary hover:underline">paul.marquina@outlook.com</a>
        </p>

        <h2 className="mt-8 text-2xl font-bold">Datos que recopilamos</h2>
        <ul className="text-text-secondary">
          <li>Email y nombre para autenticacion</li>
          <li>Fecha de nacimiento (verificacion de edad 18+)</li>
          <li>Pais (compliance fiscal multi-pais via Paddle)</li>
          <li>Historial de simuladores rendidos (puntajes, respuestas, reportes)</li>
          <li>Telemetria tecnica via Application Insights (IP truncada, user agent)</li>
          <li>Eventos UX agregados via Plausible (sin PII)</li>
        </ul>

        <h2 className="mt-8 text-2xl font-bold">Finalidades</h2>
        <ul className="text-text-secondary">
          <li>Prestacion del servicio de simulador de certificaciones</li>
          <li>Generacion de reportes personalizados de preparacion</li>
          <li>Comunicaciones operativas (compras, renovaciones, correcciones criticas)</li>
          <li>Comunicaciones de marketing (solo con consentimiento explicito)</li>
          <li>Cumplimiento legal y fiscal</li>
        </ul>

        <h2 className="mt-8 text-2xl font-bold">Tus derechos</h2>
        <p className="text-text-secondary">
          Conforme a la Ley 29733 tienes derecho a acceder, rectificar, cancelar y oponerte al
          tratamiento de tus datos personales. Puedes ejercer estos derechos enviando un correo
          a <a href="mailto:paul.marquina@outlook.com" className="text-accent-primary hover:underline">paul.marquina@outlook.com</a>{' '}
          con tu identificacion.
        </p>

        <h2 className="mt-8 text-2xl font-bold">Eliminacion de cuenta</h2>
        <p className="text-text-secondary">
          Puedes solicitar la eliminacion completa desde tu cuenta (/app/account &gt; Eliminar cuenta).
          Tu PII sera anonimizada en menos de 30 dias. Conservaremos historicos contables agregados
          conforme requerimientos fiscales SUNAT.
        </p>

        <h2 className="mt-8 text-2xl font-bold">Transferencia internacional</h2>
        <p className="text-text-secondary">
          Tus datos se almacenan en servidores de Microsoft Azure region East US 2 (Estados Unidos).
          Esta transferencia esta cubierta por las clausulas contractuales tipo y por el regimen
          de proteccion certificado de Microsoft.
        </p>

        <hr className="my-8 border-border-subtle" />

        <p className="text-xs text-text-tertiary">
          <strong>NOTA:</strong> Este es un borrador inicial pendiente de revision por asesor
          legal peruano. La version final se publicara antes del go-live. Ver tarea
          {' '}<code className="font-mono">RC-LEGAL-001</code> Sprint 15.
        </p>
      </div>
    </div>
  );
}
